import { Contact, PatientPreferencesResponse } from "../../../../../../../services/api-client/contact-api";

export const getDefaultFamilyMember = (patientPreferences: PatientPreferencesResponse, familyMembers: Contact[]) => {
  return familyMembers[
    familyMembers.findIndex(
      familyMemeber => familyMemeber.id == patientPreferences.familyCommunicationReceiverId
    )
  ];
};